import {
  customLogo,
  emergencyFundLogo,
  generationalWealthLogo,
  homeLogo,
  retirementLogo,
  trumpSidecarGoalIcon,
  vacationLogo,
} from "@assets";
import { GoalType } from "@ctypes";
import { useTheme } from "@hooks";
import { GoalIconProps } from "./types";

export const GoalIcon = ({ type = GoalType.GenerationalWealth, size = 24 }: GoalIconProps) => {
  const { theme } = useTheme();

  const icon: Record<GoalType, JSX.Element> = {
    [GoalType.House]: <img alt="house" src={homeLogo} width={size} height={size} />,
    [GoalType.Vacation]: <img alt="vacation" src={vacationLogo} width={size} height={size} />,
    [GoalType.Education]: (
      <img alt="education" src={generationalWealthLogo} width={size} height={size} />
    ),
    [GoalType.EmergencyFund]: (
      <img alt="emergency" src={emergencyFundLogo} width={size} height={size} />
    ),
    [GoalType.GenerationalWealth]: (
      <img alt="retirement" src={generationalWealthLogo} width={size} height={size} />
    ),
    [GoalType.NewCar]: <img alt="car" src={generationalWealthLogo} width={size} height={size} />,
    [GoalType.Retirement]: <img alt="retirement" src={retirementLogo} width={size} height={size} />,
    [GoalType.Custom]: <img alt="custom" src={customLogo} width={size} height={size} />,
    [GoalType.TrumpAccountSidecar]: (
      <img
        alt="trump account sidecar"
        src={trumpSidecarGoalIcon}
        width={Math.round(size * 0.75)}
        height={Math.round(size * 0.75)}
      />
    ),
    [GoalType.HighYieldSavings]: (
      <img alt="high yield savings" src={generationalWealthLogo} width={size} height={size} />
    ),
  };

  if (!type) return null;

  if (type === GoalType.TrumpAccountSidecar) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: theme.goal.icons.trumpSidecar,
          flexShrink: 0,
        }}
      >
        {icon[type]}
      </div>
    );
  }

  return icon[type];
};
